package com.volkswagen.vocs.grip

import kotlin.Exception
import kotlin.Int
import kotlin.String
import kotlinx.serialization.Serializable

@Serializable
public data class Fault(
  public val type: String,
  public val title: String,
  public val details: String,
  public val status: Int,
  public val instance: String,
  public val stackTrace: String? = null,
  public val input: String? = null,
) : Exception()
